/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 5/28/15.
 */
'use strict';
angular.module('prism-ui.package').factory('CollaboratorViewDataTransformer', function () {
	return {
		actorsColumns: [
			{
				name: 'checkMarkRowHeaderCol',
				field: 'checkMark',
				width: '2%',
				enableColumnMenu: false,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'components/visual/grid/check-mark-template.html',
				headerCellTemplate: 'package/editor/components/view/collaborator/grid-checkbox-header-template.html'
			},
			{
				field: 'collaborator.displayName',
				width: '25%',
				displayName: 'Actor',
				sort: {
					direction: 'asc',
					priority: 0
				}
			},
			{
				field: 'collaborator.nickname',
				width: '25%',
				displayName: 'Nickname',
				enableColumnMenu: false
			},
			{
				field: 'character',
				width: '25%',
				displayName: 'Character',
				enableColumnMenu: false
			},
			{
				field: 'collaborator.iMDbNumber',
				enableColumnMenu: false,
				name: 'imdbColumn',
				displayName: 'IMDB#',
				width: '23%',
				enableSorting: false,
				enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/hyperlink-template.html'
			}
		],
		crewColumns: [
			{
				name: 'checkMarkRowHeaderCol',
				field: 'checkMark',
				width: '2%',
				enableColumnMenu: false,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'components/visual/grid/check-mark-template.html',
				headerCellTemplate: 'package/editor/components/view/collaborator/grid-checkbox-header-template.html'
			},
			{
				field: 'collaborator.displayName',
				width: '30%',
				displayName: 'Collaborator',
				sort: {
					direction: 'asc',
					priority: 0
				}
			},
			{
				field: 'collaborator.nickname',
				width: '25%',
				displayName: 'Nickname',
				enableColumnMenu: false
			},
			{
                field: 'collaborator.iMDbNumber',
                enableColumnMenu: false,
				name: 'imdbColumn',
				displayName: 'IMDB#',
				width: '23%',
				minWidth: 150,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/hyperlink-template.html'
			},
			{
				field: 'role',
				displayName: 'Role',
				enableColumnMenu: false,
				enableSorting: true,
				name: 'role',
				width: '20%'
			}
		]
	};
});
